import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/components/landing/constants";

/**
 * Waitlist form hook. Used by FinalCTA + Footer.
 * Returns the email state, loading flag, and an onSubmit handler.
 */
export function useWaitlistForm(source, successMessage = "You're in. We'll be in touch.") {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email: email.trim(), source });
      toast.success(successMessage);
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return { email, setEmail, loading, onSubmit };
}
